import React, { useState } from "react";
import axios from "../axios";
import Header from "../Pages/Header";
import { API_BASE_URL } from "../config";

export default function Register() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
  });
  const [message, setMessage] = useState("");

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/register`, form);
      setMessage("Registered successfully");
    } catch (err) {
      setMessage("Registration failed");
    }
  };

  return (
    <>
      {" "}
      <Header />
      <form onSubmit={handleSubmit}>
        <h2>Register</h2>
        <input
          name="name"
          placeholder="Name"
          onChange={handleChange}
          required
        />
        <input
          name="email"
          placeholder="Email"
          type="email"
          onChange={handleChange}
          required
        />
        <input
          name="password"
          placeholder="Password"
          type="password"
          onChange={handleChange}
          required
        />
        <input
          name="password_confirmation"
          placeholder="Confirm Password"
          type="password"
          onChange={handleChange}
          required
        />
        <button type="submit">Register</button>
        <p>{message}</p>
      </form>
    </>
  );
}
